export default "__VITE_ASSET__eb5a2fda__"